import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Toaster } from '@shared/components/ui/toaster';
import ErrorBoundary from '@shared/components/ErrorBoundary';
import { ThemeProvider } from '@shared/hooks/useTheme';
import { PublicRoutes } from '@/router';
import { PortalRoutes } from '@/portalRouter';

/**
 * Portal App — handles supplier portal (/portal/*) and public invite (/i/*) routes.
 * No Supabase Auth — portal uses its own OTP/JWT session.
 */
function AppRouter() {
  const location = useLocation();
  const isPublicRoute = location.pathname === '/i' || location.pathname.startsWith('/i/');

  // Redirect root to portal entry
  if (location.pathname === '/') {
    return <Navigate to="/portal" replace />;
  }

  if (isPublicRoute) {
    return (
      <ErrorBoundary>
        <Helmet>
          <title>Site Induction</title>
          <meta name="description" content="Complete your site induction" />
        </Helmet>
        <div className="min-h-screen bg-background">
          <PublicRoutes />
        </div>
        <Toaster />
      </ErrorBoundary>
    );
  }

  // Supplier portal — redirect root to /portal
  return (
    <ErrorBoundary>
      <Helmet>
        <title>Supplier Portal</title>
        <meta name="description" content="Supplier portal access" />
      </Helmet>
      <PortalRoutes />
      <Toaster />
    </ErrorBoundary>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AppRouter />
      </ThemeProvider>
    </BrowserRouter>
  );
}
